const adminMeetingRouter = [
  {
    path: '/admin/m',
    name: 'AdminMeetingIndex',
    component: () => import('@/views/admin/meeting/index')
  },
  {
    path: '/admin/m/create',
    name: 'AdminMeetingCreate',
    component: () => import('@/views/admin/meeting/create')
  },
  {
    path: '/admin/m/edit',
    name: 'AdminMeetingEdit',
    component: () => import('@/views/admin/meeting/edit')
  },
  {
    path: '/admin/m/link',
    name: 'AdminMeetingLink',
    component: () => import('@/views/admin/meeting/link')
  },
  {
    path: '/admin/m/member/statistics',
    name: 'AdminMeetingMemberStatistics',
    component: () => import('@/views/admin/meeting/member/statistics')
  },
  {
    path: '/admin/m/track',
    name: 'AdminMeetingTrack',
    component: () => import('@/views/admin/meeting/track')
  },
  {
    path: '/admin/m/track/cg',
    name: 'AdminMeetingTrackCg',
    component: () => import('@/views/admin/meeting/trackCg')
  },
  {
    path: '/admin/m/member',
    name: 'AdminMeetingMember',
    component: () => import('@/views/admin/meeting/member/index')
  },
  {
    path: '/admin/m/member/create',
    name: 'AdminMeetingMemberCreate',
    component: () => import('@/views/admin/meeting/member/create')
  },
  {
    path: '/admin/m/member/multi_create',
    name: 'AdminMeetingMemberMultiCreate',
    component: () => import('@/views/admin/meeting/member/multiCreate')
  },
  {
    path: '/admin/m/member/log',
    name: 'AdminMeetingMemberLog',
    component: () => import('@/views/admin/meeting/member/log')
  },
  {
    path: '/admin/m/member/track',
    name: 'AdminMeetingMemberTrack',
    component: () => import('@/views/admin/meeting/member/track')
  },
  {
    path: '/admin/m/signer',
    name: 'AdminMeetingSigner',
    component: () => import('@/views/admin/meeting/signer')
  },
  {
    path: '/admin/m/apply',
    name: 'AdminMeetingApply',
    component: () => import('@/views/admin/meeting/apply')
  },
  {
    path: '/admin/m/seat/conf',
    name: 'AdminMeetingSeatConf',
    component: () => import('@/views/admin/meeting/seat/conf')
  },
  {
    path: '/admin/m/printer',
    name: 'AdminMeetingPrinter',
    component: () => import('@/views/admin/meeting/printer')
  }
]

export default adminMeetingRouter



// WEBPACK FOOTER //
// ./src/router/modules/admin/meeting.js